import { useNavigate } from 'react-router-dom';
import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { ErrorMessages } from '@types';
import { ZodError } from 'zod';
import { useEVChargerStore } from '../../../../hooks/useEVChargerStore';
import { useHandleSubmit } from '../../../../hooks/useHandleSubmit';
import { RoutesList } from '../../../routes/Routes';
import { parseZodErrors } from '@utils';
import { SELECT_WANT_EMAIL_ERROR } from '../../../../constants/errors';
import { EVChargerPayload } from '../payload/Payload';
import { BinaryOptionType } from '@shared/types';

export const EmailConfirmation = () => {
  const navigate = useNavigate();
  const {
    data: { wantConfirmationEmail },
    update,
    get,
  } = useEVChargerStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title = 'Do you want a confirmation email of your report?';
  const [submitLoading, setSubmitLoading] = useState(false);
  const { mutateAsync, isPending } = useHandleSubmit();
  const payload = EVChargerPayload();

  const handleChange = (option: string) => {
    update('wantConfirmationEmail', option as BinaryOptionType);
    setErrorMessages([]);
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: wantConfirmationEmail === 'Yes',
      isLabelBold: false,
    },
    {
      labelText: 'No',
      isDefault: wantConfirmationEmail === 'No',
      isLabelBold: false,
    },
  ];

  const handleNext = async () => {
    setSubmitLoading(true);
    try {
      SELECT_WANT_EMAIL_ERROR.parse({
        SELECT_WANT_EMAIL_ERROR: get('wantConfirmationEmail'),
      });
      if (wantConfirmationEmail === 'No') {
        await mutateAsync(payload);
        !isPending && navigate(RoutesList.CONFIRMATION);
      } else {
        navigate(RoutesList.YOUR_DETAILS);
      }
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
      setSubmitLoading(false);
    }
  };

  const buttonNext = {
    label: wantConfirmationEmail === 'No' ? 'Submit' : 'Next',
    onClick: handleNext,
    loading: isPending || submitLoading,
  };

  const buttonPrevious = {
    disabled: isPending || submitLoading,
    onClick: () => {
      navigate(RoutesList.TELL_US_MORE);
    },
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      errorPath={'SELECT_WANT_EMAIL_ERROR'}
      errorMessages={errorMessages}
      options={options}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
